import React from 'react'
import { useParams } from 'react-router-dom'
import Tracker from '../Tracker'
import GlobalSmallCapLaunch from './GlobalSmallCapLaunch.tsx'

const CompanyNews = ({navHeight}: {navHeight: number}) => {
  const { newsId } = useParams()

  return (
    <div style={{paddingTop:navHeight, backgroundColor:'white'}}>
            <Tracker page={`News-${newsId}`}/>
            {newsId === 'global-small-cap-launch' && <GlobalSmallCapLaunch />}
            </div>
  )
}

export default CompanyNews